import {Injectable} from '@angular/core';
@Injectable()
export class ServiceCarrito {
    carreras: any = [
        {
          nombre: 'Licenciatura en Administración',
          tipo: 'Licenciatura',
          duracion: '5',
          sede: 'Villa Mercedes',
          titulo: 'Licenciado/a en Administración',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-administracion'   
        },
        {
          nombre: 'Licenciatura en Biología Molecular',
          tipo: 'Licenciatura',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Licenciado en Biología Molecular',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-bio-molec'   
        },
        {
          nombre: 'Licenciatura en Bioquímica',
          tipo: 'Licenciatura',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Licenciatura en Bioquímica',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-bioquimica'   
        },
        {
          nombre: 'Licenciatura en Biotecnología',
          tipo: 'Licenciatura',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Biotecnología',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-biotecnologia'   
        },    
        {
          nombre: 'Licenciatura en Ciencias y Tecnología de los Alimentos',
          tipo: 'Licenciatura',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Ciencia y Tecnología de los Alimentos',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-cs-tec-alim'  
        },
        {
          nombre: 'Licenciatura en Ciencias Biológicas',
          tipo: 'Licenciatura',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Ciencias Biológicas',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-cs-bio'  
        },
        {
          nombre: 'Licenciatura en Ciencias de la Computación',
          tipo: 'Licenciatura',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Ciencias de la Computación',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-cs-comp'  
        },
        {
          nombre: 'Licenciatura en Ciencias de la Educación',
          tipo: 'Licenciatura',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Ciencias de la Educación',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-cs-edu'  
        },
        {
          nombre: 'Licenciatura en Ciencias Geológicas',
          tipo: 'Licenciatura',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Ciencias Geológicas',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-cs-geo'  
        },
        {
          nombre: 'Licenciatura en Ciencias Matemáticas',
          tipo: 'Licenciatura',
          duracion: '4',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Ciencias Matemáticas',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-cs-mat'  
        },
        {
          nombre: 'Licenciatura en Comunicación Social',
          tipo: 'Licenciatura',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Comunicación Social',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-com-soc'  
        },
        {//ACA NO SE SABEN LOS AÑOS
          nombre: 'Licenciatura en Educación Especial',
          tipo: 'Licenciatura (Ciclo complementario)',
          duracion: '2',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Educación Especial',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-edu-esp'  
        },
        {
          nombre: 'Licenciatura en Educación Inicial',
          tipo: 'Licenciatura',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Educación Inicial',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-edu-inicial'  
        },
        {
          nombre: 'Licenciatura en Enfermería',
          tipo: 'Licenciatura',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Enfermería',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-enferm'  
        },
        {
          nombre: 'Licenciatura en Fonoaudiología',
          tipo: 'Licenciatura',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Fonoaudiología',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-fono'  
        },
        {
          nombre: 'Licenciatura en Física',
          tipo: 'Licenciatura',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Licenciatura en Física',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-fisica'  
        },
        {
          nombre: 'Licenciatura en Hotelería',
          tipo: 'Licenciatura',
          duracion: '4',
          sede: 'Merlo',
          titulo: 'Licenciado/a en Hotelería',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-hoteleria'  
        },
        {
          nombre: 'Licenciatura en Kinesiología y Fisiatría',
          tipo: 'Licenciatura',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Kinesiología y Fisiatría',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-kine'  
        },
        {
          nombre: 'Licenciatura en Matemática Aplicada',
          tipo: 'Licenciatura',
          duracion: '4',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Matemática Aplicada',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-mat-ap'  
        },
        {
          nombre: 'Licenciatura en Nutrición',
          tipo: 'Licenciatura',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Nutrición',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-nutri'  
        },
        {
          nombre: 'Licenciatura en Periodismo',
          tipo: 'Licenciatura',
          duracion: '4',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Periodismo',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-periodismo'  
        },
        {
          nombre: 'Licenciatura en Producción de Radio y Televisión',
          tipo: 'Licenciatura',
          duracion: '4',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Producción de Radio y Televisión',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-prod-radio-tv'  
        },
        {
          nombre: 'Licenciatura en Psicología',
          tipo: 'Licenciatura',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Psicología',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-psico'  
        },
        {//ACA NO SE SABEN LOS AÑOS
          nombre: 'Licenciado en Psicomotricidad',
          tipo: 'Licenciatura',
          duracion: '4',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Psicomotricidad',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-psicomot'  
        },
        {
          nombre: 'Licenciatura en Química',
          tipo: 'Licenciatura',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Licenciado/a en Química',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-quim'  
        },
        {
          nombre: 'Licenciatura en Trabajo Social',
          tipo: 'Licenciatura',
          duracion: '5',
          sede: 'Villa Mercedes',
          titulo: 'Licenciado/a en Trabajo Social',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-trab-social'  
        },
        {
          nombre: 'Licenciatura en Turismo',
          tipo: 'Licenciatura',
          duracion: '4',
          sede: 'Merlo',
          titulo: 'Licenciado/a en Turismo',
          enlace: 'https://carreras.unsl.edu.ar/carreras/lic-turismo'  
        },
        {
          nombre: 'Ingeniería Agronómica',
          tipo: 'Ingeniería',
          duracion: '5',
          sede: 'Villa Mercedes',
          titulo: 'Ingeniero/a Agronómo',
          enlace: 'https://carreras.unsl.edu.ar/carreras/ing-agronomica'  
        },
        {
          nombre: 'Ingeniería Electromecánica',
          tipo: 'Ingeniería',
          duracion: '5',
          sede: 'Villa Mercedes',
          titulo: 'Ingeniero/a Electromecánico',
          enlace: 'https://carreras.unsl.edu.ar/carreras/ing-electromec'  
        },{
          nombre: 'Ingeniería Electrónica',
          tipo: 'Ingeniería',
          duracion: '5',
          sede: 'Villa Mercedes',
          titulo: 'Ingeniero/a Electrónico',
          enlace: 'https://carreras.unsl.edu.ar/carreras/ing-electronica'  
        },{
          nombre: 'Ingeniería Electrónica con Orientación en Sistemas Digitales',
          tipo: 'Ingeniería',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Ingeniero/a en Electrónico con Orientación en Sistemas Digitales',
          enlace: 'https://carreras.unsl.edu.ar/carreras/ing-electronica-osd'  
        },{
          nombre: 'Ingeniería en Alimentos',
          tipo: 'Ingeniería',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Ingeniero/a en Alimentos',
          enlace: 'https://carreras.unsl.edu.ar/carreras/ing-alimentos-sl'  
        },
        {
          nombre: 'Ingeniería en Alimentos',
          tipo: 'Ingeniería',
          duracion: '5',
          sede: 'Villa Mercedes',
          titulo: 'Ingeniero/a en Alimentos',
          enlace: 'https://carreras.unsl.edu.ar/carreras/ing-alimentos-vm'  
        },
        {
          nombre: 'Ingeniería en Computación',
          tipo: 'Ingeniería',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Ingeniero/a en Computación',
          enlace: 'https://carreras.unsl.edu.ar/carreras/ing-computacion'  
        },
        {
          nombre: 'Ingeniería en Informática',
          tipo: 'Ingeniería',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Ingeniero/a en Informática',
          enlace: 'https://carreras.unsl.edu.ar/carreras/ing-informatica'  
        },        
        {
          nombre: 'Ingeniería en Minas',
          tipo: 'Ingeniería',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Ingeniero/a en Minas',
          enlace: 'https://carreras.unsl.edu.ar/carreras/ing-minas'  
        },
        {
          nombre: 'Ingeniería Industrial',
          tipo: 'Ingeniería',
          duracion: '5',
          sede: 'Villa Mercedes',
          titulo: 'Ingeniero/a Industrial',
          enlace: 'https://carreras.unsl.edu.ar/carreras/ing-industrial'  
        },
        {
          nombre: 'Ingeniería Mecatrónica',
          tipo: 'Ingeniería',
          duracion: '5',
          sede: 'Villa Mercedes',
          titulo: 'Ingeniero/a Mecatrónico',
          enlace: 'https://carreras.unsl.edu.ar/carreras/ing-mecatronica'  
        },
        {
          nombre: 'Ingeniería Química',
          tipo: 'Ingeniería',
          duracion: '5',
          sede: 'Villa Mercedes',
          titulo: 'Ingeniero/a Químico',
          enlace: 'https://carreras.unsl.edu.ar/carreras/ing-quimica'  
        },
        {
          nombre: 'Profesorado en Ciencias de la Computación',
          tipo: 'Profesorado',
          duracion: '4',
          sede: 'San Luis',
          titulo: 'Profesor/a en Ciencias de la Computación',
          enlace: 'https://carreras.unsl.edu.ar/carreras/prof-cs-comp'  
        },
        {
          nombre: 'Profesorado en Ciencias de la Educación',
          tipo: 'Profesorado',
          duracion: '4',
          sede: 'San Luis',
          titulo: 'Profesor/a en Ciencias de la Educación',
          enlace: 'https://carreras.unsl.edu.ar/carreras/prof-cs-edu'  
        },
        {
          nombre: 'Profesorado de Educación Especial',
          tipo: 'Profesorado',
          duracion: '4',
          sede: 'San Luis',
          titulo: 'Profesor/a de Educación Especial',
          enlace: 'https://carreras.unsl.edu.ar/carreras/prof-edu-esp'  
        },
        {
          nombre: 'Profesorado de Educación Inicial',
          tipo: 'Profesorado',
          duracion: '4',
          sede: 'San Luis',
          titulo: 'Profesor/a en Educación Inicial',
          enlace: 'https://carreras.unsl.edu.ar/carreras/prof-edu-inic'  
        },
        {
          nombre: 'Profesorado en Física',
          tipo: 'Profesorado',
          duracion: '4',
          sede: 'San Luis',
          titulo: 'Profesor/a de Física',
          enlace: 'https://carreras.unsl.edu.ar/carreras/prof-fisica'  
        },
        {
          nombre: 'Profesorado en Matemática',
          tipo: 'Profesorado',
          duracion: '4',
          sede: 'San Luis',
          titulo: 'Profesor/a de Matemática',
          enlace: 'https://carreras.unsl.edu.ar/carreras/prof-mat'  
        },
        {
          nombre: 'Profesorado en Química',
          tipo: 'Profesorado',
          duracion: '4',
          sede: 'San Luis',
          titulo: 'Profesor/a de Química',
          enlace: 'https://carreras.unsl.edu.ar/carreras/prof-quim'  
        },
        {
          nombre: 'Profesorado en Tecnología Electrónica',
          tipo: 'Profesorado',
          duracion: '4',
          sede: 'San Luis',
          titulo: 'Profesor/a de Tecnología Electrónica',
          enlace: 'https://carreras.unsl.edu.ar/carreras/prof-tec-elec'  
        },
        {
          nombre: 'Profesorado en Psicología',
          tipo: 'Profesorado',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Profesor/a en Psicología',
          enlace: 'https://carreras.unsl.edu.ar/carreras/prof-psico'  
        },
        {
          nombre: 'Profesorado Universitario en Biología',
          tipo: 'Profesorado',
          duracion: '4',
          sede: 'San Luis',
          titulo: 'Profesor/a Universitario/a en Biología',
          enlace: 'https://carreras.unsl.edu.ar/carreras/prof-bio'  
        },
        {
          nombre: 'Profesorado Universitario en Letras',
          tipo: 'Profesorado',
          duracion: '4',
          sede: 'San Luis',
          titulo: 'Profesor/a en Letras',
          enlace: 'https://carreras.unsl.edu.ar/carreras/prof-letras'  
        },
        {
          nombre: 'Profesorado Universitario en Música Popular Latinoamericana',
          tipo: 'Profesorado',
          duracion: '4',
          sede: 'San Luis',
          titulo: 'Profesor/a Universitario/a en Música Popular Latinoamericana',
          enlace: 'https://carreras.unsl.edu.ar/carreras/prof-musica-pop'  
        },
        {
          nombre: 'Abogacía',
          tipo: 'Otro',
          duracion: '5',
          sede: 'Villa Mercedes',
          titulo: 'Abogado/a',
          enlace: 'https://carreras.unsl.edu.ar/carreras/abogacia'  
        },
        {
          nombre: 'Analista Químico',
          tipo: 'Otro',
          duracion: '3',
          sede: 'San Luis',
          titulo: 'Analista Químico',
          enlace: 'https://carreras.unsl.edu.ar/carreras/analista-quimico'  
        },
        {
          nombre: 'Bromatología',
          tipo: 'Otro',
          duracion: '3',
          sede: 'San Luis',
          titulo: 'Bromatologo/a',
          enlace: 'https://carreras.unsl.edu.ar/carreras/bromatologia'  
        },
        {
          nombre: 'Contador Público Nacional',
          tipo: 'Otro',
          duracion: '5',
          sede: 'Villa Mercedes',
          titulo: 'Contador/a Público Nacional',
          enlace: 'https://carreras.unsl.edu.ar/carreras/cpn'  
        },
        {
          nombre: 'Farmacia',
          tipo: 'Otro',
          duracion: '5',
          sede: 'San Luis',
          titulo: 'Farmaceutico/a',
          enlace: 'https://carreras.unsl.edu.ar/carreras/farmacia'  
        },
        {
          nombre: 'Guía Universitario de Turismo',
          tipo: 'Otro',
          duracion: '3',
          sede: 'Merlo',
          titulo: 'Guía Universitario de Turismo',
          enlace: 'https://carreras.unsl.edu.ar/carreras/guia-turismo'  
        },
        {
          nombre: 'Martillero y Corredor Público',
          tipo: 'Otro',
          duracion: '3',
          sede: 'Villa Mercedes',
          titulo: 'Martillero y Corredor Público',
          enlace: 'https://carreras.unsl.edu.ar/carreras/martillero-pub'  
        },
        {
          nombre: 'Procurador',
          tipo: 'Otro',
          duracion: '4',
          sede: 'Villa Mercedes',
          titulo: 'Procurador',
          enlace: 'https://carreras.unsl.edu.ar/carreras/procurador'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Acompañamiento Terapéutico',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'Villa Mercedes',
          titulo: 'Técnico/a Universitario en Acompañamiento Terapéutico',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-acom-terap'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Asistencia Jurídica',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'Villa Mercedes',
          titulo: 'Técnico/a Universitario en Asistencia Jurídica',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-asist-jurid'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Automatización Industrial Orientación Informática',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'Villa Mercedes',
          titulo: 'Técnico/a Universitario en Automatización Industrial Orientación Informática',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-auto-ind'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Diseño Mecánico Orientación Informática',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'Villa Mercedes',
          titulo: 'Técnico/a Universitario en Diseño Mecánico Orientación Informática',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-dis-mec'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Electrónica',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'San Luis',
          titulo: 'Técnico/a Universitario en Electrónica',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-elec'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Energías Renovables',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'San Luis',
          titulo: 'Técnico/a Universitario en Energías Renovables',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-ene-renov'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Esterilización',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'San Luis',
          titulo: 'Técnico/a Universitario en Esterilización',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-ester'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Explotación Minera',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'San Luis',
          titulo: 'Técnico/a Universitarioen Explotación Minera',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-min'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Fotografía',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'San Luis',
          titulo: 'Técnico/a Universitario en Fotografía',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-foto'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Acompañamiento Terapéutico',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'Villa Mercedes',
          titulo: 'Técnico/a Universitario en Acompañamiento Terapéutico',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-acom-terap'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Geoinformática',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'San Luis',
          titulo: 'Técnico/a Universitario en Geoinformática',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-geoinfo'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Gestión Financiera',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'Villa Mecedes',
          titulo: 'Técnico/a Universitario en Gestión Financiera',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-gest-financiera'  
        },
        {
          nombre: 'Tecnicatura en Gestión Hotelera',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'Merlo',
          titulo: 'Técnico/a Universitario en Gestión Hotelera',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-gest-hotelera'  
        },
        {
          nombre: 'Tecnicatura en Gestión Turística',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'Merlo',
          titulo: 'Técnico/a Universitario en Gestión Turística',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-gest-turis'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Higiene y Seguridad en el Trabajo',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'San Luis',
          titulo: 'Técnico/a Universitario en Higiene y Seguridad en el Trabajo',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-hig-seg'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Laboratorios Biológicos',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'San Luis',
          titulo: 'Técnico/a Universitario en Laboratorios Biológicos',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-lab-bio'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Mantenimiento Industrial',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'Villa Mercedes',
          titulo: 'Técnico/a Universitario en Mantenimiento Industrial',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-mantenim-ind'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Obras Viales',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'San Luis',
          titulo: 'Técnico/a Universitario en Obras Viales',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-ob-via'  
        },
        {
          nombre: 'Tecnicatura en Parques, Jardines y Floricultura',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'Merlo',
          titulo: 'Técnico/a Universitario en Parques, Jardines y Floricultura',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-parques'  
        },
        /*{
          nombre: 'Tecnicatura Universitaria en Procesamiento de Minerales',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'San Luis',
          titulo: 'Técnico/a Universitario en Procesamiento de Minerales',
          enlace: 'https://carreras.unsl.edu.ar/carrera/fcfmyn/tec-un-proc-mina'  
        },*/
        {
          nombre: 'Tecnicatura Universitaria en Producción Apícola (no abre en el año 2021)',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'Villa Mercedes',
          titulo: 'Técnico/a Universitario en Producción Apícola',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-prod-api'  
        },
        {
          nombre: 'Tecnicatura en Producción de Plantas Aromáticas',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'Merlo',
          titulo: 'Técnico/a Universitario en Producción de Plantas Aromáticas',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-prod-plantas'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Producción Musical',
          tipo: 'Tecnicatura',
          duracion: '4',
          sede: 'San Luis',
          titulo: 'Técnico/a Universitario en Producción Musical',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-prod-musical'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Redes de Computadoras',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'San Luis',
          titulo: 'Técnico/a Universitario en Redes de Computadoras',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-redes-comp'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Telecomunicaciones',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'San Luis',
          titulo: 'Técnico/a Universitario en Telecomunicaciones',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-telecom'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Web',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'San Luis',
          titulo: 'Técnico/a Universitario en Web',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-web'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Gestión de Organizaciones Deportivas',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'San Luis',
          titulo: 'Técnico/a Universitario/a en Gestión de Organizaciones deportivas',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-gest-org-depor'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Administración y Gestión Judicial',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'San Luis',
          titulo: 'Técnico/a Universitario/a en Administración y Gestión Judicial',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-adm-ges-jud'  
        },
        {
          nombre: 'Tecnicatura en Administración y Gestión de Instituciones Universitarias',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'San Luis',
          titulo: 'Técnico/a Administración y Gestión de Instituciones Universitarias',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-adm-gest-univ'  
        },
        {
          nombre: 'Tecnicatura Universitaria en Secretariado Ejecutivo',
          tipo: 'Tecnicatura',
          duracion: '3',
          sede: 'San Luis',
          titulo: 'Técnico/a Universitario/a en Secretariado Ejecutivo',
          enlace: 'https://carreras.unsl.edu.ar/carreras/tec-sec-ejec'  
        },
      ]
 constructor() {
     
  }
 getCarreras(){
   return this.carreras;
 }
}